import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

export const fallback = 'en'

export const languages = [
  'da',
  // "de",
  'en',
  'es',
  'fr',
  'hu',
  'id',
  'it',
  'pl',
  'pt',
  'pt-BR',
  'ro',
  'ru',
  'tr',
  'vi',
  'zh-TW',
]

i18next.use(initReactI18next).init({
  fallbackLng: fallback,
  //NOTE seems useTranslation hook load corresponding ns, don't
  // ns: ["translations", "payMerchant", "values", "about", "security", "defi"],
  // defaultNS: "translations",
  returnObjects: true,
  interpolation: {
    escapeValue: false,
  },
  react: {
    wait: true,
    // useSuspense: false,
  },
  //NOTE don't need i18n debug info in dev mode now, can uncomment when need it
  // debug: process.env.NODE_ENV === "development",
})

/**
 * NOTE: Specific site need to show corresponding languages.
 *       Add the config blow and export it.
 *       import the corresponding config from getStaticSiteConfig.
 */

// WR-665 Brazil site shows pt-BR, other sites show pt
export const brSiteLanguages = [
  'da',
  // "de",
  'en',
  'es',
  'fr',
  'hu',
  'id',
  'it',
  'pl',
  'pt-BR',
  'ro',
  'ru',
  'tr',
  'vi',
  'zh-TW',
]

export const trSiteLanguages = ['en', 'tr']

export const eeaSiteLanguages = ['en']

// WR-665 Brazil site shows pt-BR, other sites show pt
export const regularSiteLanguages = [
  'da',
  // "de",
  'en',
  'es',
  'fr',
  'hu',
  'id',
  'it',
  'pl',
  'pt',
  'ro',
  'ru',
  'tr',
  'vi',
  'zh-TW',
]

export const frSiteLanguages = ['en', 'fr']

i18next.languages = languages

export default i18next
